import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  addJobsPostingsRoute,
  jobPostingsKey,
  SubmitJobPosting,
} from '@features/jobPostings';
import { errorMessage } from '@features/positions';
import axiosInstance from '@server/axiosInstance';
import { tampleteJobPostingRoute } from '../api/constants';
import { TemplateSubmitJobPosting } from '../types';
import { templateList } from '../constants';

type useAddTemplateJobPostingProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useAddTemplateJobPosting = ({
  setErrorText = () => { },
}: useAddTemplateJobPostingProps) => {
  const client = useQueryClient();

  const { mutate: addJobPosting, isLoading: isAddingJobPosting } = useMutation({
    mutationFn: (variables: SubmitJobPosting) =>
      axiosInstance
        .post(tampleteJobPostingRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        setErrorText('');
        client.invalidateQueries(jobPostingsKey);
        client.invalidateQueries(templateList);
      } else {
        setErrorText(data?.message ?? errorMessage);
      }
    },
    onError: () => setErrorText(errorMessage),
  });

  return { addJobPosting, isAddingJobPosting };
};
